import { Fragment } from 'react'
import { parseMarkdown, type MdSpan } from '@/lib/poTemplate/markdown'

/**
 * A template text block as React elements. Built from the parsed tree, never
 * from markup: no dangerouslySetInnerHTML, so whatever a template holds is
 * rendered as text.
 */
export function PoMarkdown({ text, className }: { text: string | null | undefined; className?: string }) {
  const blocks = parseMarkdown(text)
  if (blocks.length === 0) return null
  return (
    <div className={className}>
      {blocks.map((b, i) => {
        switch (b.type) {
          case 'h1':
            return <h3 key={i} className='mb-1 mt-2 text-[11pt] font-bold'><Spans spans={b.spans} /></h3>
          case 'h2':
            return <h4 key={i} className='mb-1 mt-2 text-[10pt] font-semibold'><Spans spans={b.spans} /></h4>
          case 'h3':
            return <h5 key={i} className='mb-0.5 mt-1.5 font-semibold'><Spans spans={b.spans} /></h5>
          case 'p':
            return <p key={i} className='mb-1.5'><Spans spans={b.spans} /></p>
          case 'ul':
          case 'ol': {
            const List = b.type
            return (
              <List key={i} className={`mb-1.5 pl-5 ${b.type === 'ul' ? 'list-disc' : 'list-decimal'}`}>
                {b.items.map((item, j) => (
                  <li key={j}><Spans spans={item} /></li>
                ))}
              </List>
            )
          }
        }
      })}
    </div>
  )
}

function Spans({ spans }: { spans: MdSpan[] }) {
  return (
    <>
      {spans.map((s, i) => {
        const content = s.bold ? <strong>{s.text}</strong> : s.italic ? <em>{s.text}</em> : s.text
        return (
          <Fragment key={i}>
            {s.br && <br />}
            {content}
          </Fragment>
        )
      })}
    </>
  )
}
